import React from 'react'
import './application-thank-you.css'

export function ApplicationThankYou(props) {
    if(props.thankyou) {
        return(
            <div class="thank-you-wrapper">
                <div className="thank-you-content">
                    <div className="thank-you-words-wrapper">
                        <h2 className="thankyou-title">Thank you {props.name}!</h2>
                        <p>We'll review your application shortly.</p>
                    </div>
                    <a className="thankyou-close" href={props.website}>Close</a>
                </div>
            </div>
        ) 
    } else {
        return null
    }
}
